import React, { useState, useMemo } from 'react'
import { putRequest } from '../../../services'
import { useArray, varClass, IChannelsV1List } from '../../shared'
import { MultiSelectDropdown } from './shared'
import { uniq } from 'lodash'

export const DisableModal = (props) => {
  const { campaign, hideModal, reloadCampaign, showSnackbar } = props
  // See PrioritizeModal — guard against lazy-trackers race.
  const trackers = campaign.trackers || []
  const [selectedMethod, setSelectedMethod] = useState('')

  const initialSelectedChannels = useMemo(
    () =>
      uniq(
        trackers
          .filter((tracker) => tracker.trackerIsExcluded)
          .map((tracker) => tracker.trackerChannelUuid)
      ),
    [campaign]
  )
  const {
    values: selectedChannels,
    toggle: toggleSelectedChannel,
    clear: clearSelectedChannels,
  } = useArray(initialSelectedChannels)

  const canIncludeAll = useMemo(
    () => !!initialSelectedChannels.length,
    [campaign]
  )

  const submit = async () => {
    let excludeCampaignUuids = []
    let includeCampaignUuids = []

    if (selectedMethod === 'specific') {
      if (selectedChannels.length) {
        excludeCampaignUuids = trackers
          .filter((tracker) =>
            selectedChannels.includes(tracker.trackerChannelUuid)
          )
          .map((t) => t.trackerUuid)
      } else {
        excludeCampaignUuids = []
      }
    } else if (selectedMethod === 'all') {
      excludeCampaignUuids = trackers.map((tracker) => tracker.trackerUuid)
    } else if (selectedMethod === 'none') {
      excludeCampaignUuids = []
    }

    for (const tracker of trackers) {
      if (!excludeCampaignUuids.includes(tracker.trackerUuid)) {
        includeCampaignUuids.push(tracker.trackerUuid)
      }
    }

    excludeCampaignUuids = excludeCampaignUuids.filter((uuid) => uuid)
    includeCampaignUuids = includeCampaignUuids.filter((uuid) => uuid)

    await Promise.all([
      excludeCampaignUuids.length
        ? putRequest(`/advs/v2/camps/tracking`, {
            campaignUuids: excludeCampaignUuids,
            campaignIsExcluded: true,
          })
        : null,
      includeCampaignUuids.length
        ? putRequest(`/advs/v2/camps/tracking`, {
            campaignUuids: includeCampaignUuids,
            campaignIsExcluded: false,
          })
        : null,
    ])

    showSnackbar('Tracking priority updated')
    reloadCampaign()
    hideModal()
  }

  return (
    <>
      <div className="card-body">
        <div
          onChange={(e: any) => setSelectedMethod(e.target.value)}
          className="column column-narrow"
        >
          <div className="control control-radio">
            <input type="radio" name="campaign-priority" value="all" />
            <label>Disable for all sites</label>
          </div>
          {canIncludeAll && (
            <div className="control control-radio">
              <input type="radio" name="campaign-priority" value="none" />
              <label>Enable for all sites</label>
            </div>
          )}
          <div className="control control-radio">
            <input type="radio" name="campaign-priority" value="specific" />
            <label>Disable for specific sites</label>
          </div>
        </div>

        <div
          className={varClass({
            'subnav-filters w-100 m-t-2': true,
            'disabled': selectedMethod !== 'specific',
          })}
        >
          <MultiSelectDropdown
            label="Sites"
            values={campaign.channels}
            sortKey="channelUuid"
            uuidGetter={(channel: IChannelsV1List) => channel.channelUuid}
            labelGetter={(channel: IChannelsV1List) =>
              channel.channelName || channel.channelDomain
            }
            selectedValues={selectedChannels}
            toggleSelectedValue={toggleSelectedChannel}
            clearSelectedValues={clearSelectedChannels}
          />
        </div>

        <div className="row row-end m-t-5">
          <button
            className="btn btn-dark"
            disabled={!selectedMethod}
            onClick={submit}
          >
            Update
          </button>
        </div>
      </div>
    </>
  )
}
